const createBiHelpers = async ({
  appDefId,
  metaSiteId,
  biSettings,
  wixRicosVersion,
  ricosVersion
}) => {
  const { biStrategy: biStrategy2 } = await import("./bi-strategy.js");
  return biStrategy2(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings);
};
import { biStrategy } from "./bi-strategy.js";
import { RicosBILogger } from "./ricos-bi-logger.js";
export {
  RicosBILogger,
  biStrategy,
  createBiHelpers
};
//# sourceMappingURL=index.js.map
